export default "__VITE_ASSET__Crhoz5XH__"